// extracted by mini-css-extract-plugin
export var list = "info-list-module--list--vNo2r";